import React, { useState, useRef } from "react";
import { FaPaperPlane } from "react-icons/fa";
import { sendMessageToAI } from "../api/chatBot";

const ChatInput = ({
  addMessage,
  sCurrentChatID,
  botIsLoading,
  setBotIsLoading,
  model,
}) => {
  const [message, setMessage] = useState("");
  const abortControllerRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    addMessage(message, "user");
    setBotIsLoading(true);

    try {
      setMessage("");

      const response = await sendMessageToAI(message, sCurrentChatID, model);

      let sMessage = response.message;

      addMessage(sMessage, "bot");
    } catch (error) {
      if (error.name === "AbortError") {
        addMessage("Anfrage wurde abgebrochen", "bot");
      } else {
        console.error("Error sending message:", error);
      }
    } finally {
      setBotIsLoading(false);
      abortControllerRef.current = null;
    }
  };

  return (
    <div>
      <form className="d-flex" onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Nachricht eingeben..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ height: "60px" }}
            disabled={botIsLoading}
          />

          <button
            type="submit"
            className="btn btn-primary"
            disabled={botIsLoading}
          >
            <FaPaperPlane />
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChatInput;
